import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "w-100 cart-delivery" }
const _hoisted_2 = { class: "uppercase text-raleway-13 delivery-addresses" }
const _hoisted_3 = { class: "cart-delivery-list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["id", "checked"]
const _hoisted_6 = ["for"]
const _hoisted_7 = { class: "w-100" }
const _hoisted_8 = { class: "w-100" }
const _hoisted_9 = { class: "skeleton-loading-line loading-address" }

import { Locations } from "@/store/modules/Locations/type";
import { StockType } from "@/store/modules/Stock/type";
import { computed, onBeforeMount, ref } from "vue";
import { IStore } from "@/store/types/StoreType";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'cartDeliveryComponent',
  setup(__props) {

const store = useStore<IStore>();

const locations = ref(
  computed<Locations[]>(() => store.getters?.getStockLocations)
);
const stock = ref(
  computed<StockType[]>(() => store.getters?.getStockResultsInSelectedSheldules)
);
const token = ref(computed<string>(() => store.getters.accessTokenGet));
const serverType = ref(computed<string>(() => store.getters.getServerType));
const selectAddressCart = ref(
  computed<Locations>(() => store.getters.getSelectedAddress)
);

const selectAddress = (stockLocation: Locations | null) => {
  store.commit("updateSelectedAddressCart", stockLocation);
};

onBeforeMount(() => {
  serverType.value === "retail" && !token.value
    ? console.log("no info")
    : stock.value.length <= 0 && store.dispatch("getStockDetails");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$tc("Delivery_addresses")), 1),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(locations.value, (_stock) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "pb-1 d-flex a-i-center pointer",
          key: _stock?.id || 0
        }, [
          _createElementVNode("div", {
            class: "d-flex a-i-center",
            onClick: ($event: any) => (selectAddress(_stock))
          }, [
            _createElementVNode("input", {
              type: "radio",
              name: "select-scheldules_address no-select display-none",
              id: 'radio' + _stock?.id,
              checked: _stock?.id === selectAddressCart.value?.id
            }, null, 8, _hoisted_5),
            _createElementVNode("div", {
              class: "text-motserrat-14 ml-1 no-select",
              for: 'radio' + _stock?.id
            }, [
              _createElementVNode("p", _hoisted_7, _toDisplayString(_stock?.geo_place_country +
                " " +
                _stock?.postal_code +
                " " +
                _stock.geo_place_name), 1),
              _createElementVNode("p", _hoisted_8, _toDisplayString(_stock.full_address), 1)
            ], 8, _hoisted_6)
          ], 8, _hoisted_4)
        ]))
      }), 128))
    ], 512), [
      [_vShow, !_unref(store).getters.getLocationLoading]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_9, " loaidng ", 512), [
      [_vShow, _unref(store).getters.getLocationLoading]
    ])
  ]))
}
}

})